
export const categoriesSliderOptions = (instance, options) => {
    // Check if custom slidesPerView is set via data attribute
    const customSlidesPerView = instance.getAttribute('data-slides-per-view');
    const slidesCount = customSlidesPerView ? parseInt(customSlidesPerView) : 4;

    let responsiveItemCounts = {
        1024: slidesCount < 4 ? slidesCount : 4,
    }
    let breakpoints = {}

    for (const resolution in responsiveItemCounts) {
        const count = responsiveItemCounts[resolution]

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: count,
            spaceBetween: 16,
            cssMode: false,
            pagination: {
                dynamicBullets: false,
            }
        }
    }

    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 12,
        cssMode: true,
        breakpoints: breakpoints
    }
}